import { render, staticRenderFns } from "./approveQuotes.vue?vue&type=template&id=129bc9e6&scoped=true&"
import script from "./approveQuotes.vue?vue&type=script&lang=js&"
export * from "./approveQuotes.vue?vue&type=script&lang=js&"
import style0 from "./approveQuotes.vue?vue&type=style&index=0&id=129bc9e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129bc9e6",
  null
  
)

export default component.exports